<template>
    <div class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 maxw-1750">
      <h2>{{$t('menu.suggestions')}}</h2>
      <v-card
        :loading="loading"
        class="mt-4"
      >
        <template v-if="!loading && loaded && elementData != null">
          <v-card-title v-if="!hideViewTitle">
            <v-breadcrumbs v-if="crumbs.length > 1  &&
              (!this.user.hasIosUser())"
              :items="crumbs.map((el, $index) => ({ $index, ...el, }))"
            >
              <template v-slot:item="{ item }" >
                <v-breadcrumbs-item
                  :to="item.$index < crumbs.length - 1 ? item.to : undefined"
                  :disabled="item.disabled"
                  :exact=true
                >
                  <v-icon
                    color="primary"
                    v-if="item.$index === 0"
                  >{{ item.text }} </v-icon>
                  <template v-else-if="item.$index === crumbs.length - 1">
                    <h5 class="text-subtitle-1 black--text">
                    {{ elementData.name }}
                    </h5>
                  </template>
                  <template v-else>{{ item.text }}</template>
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <v-spacer></v-spacer>
            <v-list-item-action
              v-if="ticketTypeData !== 'P' && !this.user.hasIosUser()"
              class="my-0"
            >
              <v-btn
                width="38"
                height="38"
                icon @click.stop="$event => share($event)"
              >
                <v-icon
                  color="primary"
                  size="20"
                >
                  mdi-share-variant
                </v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-action
              v-if="ticketTypeData !== 'P' && !this.user.hasIosUser()"
              class="my-0"
            >
              <v-btn
                width="38"
                height="38"
                icon @click.stop="$event => toggleFav($event)"
              >
                <v-icon
                  color="primary"
                  size="20">
                    {{ isElementInBookmark()
                    ? 'mdi-bookmark' : 'mdi-bookmark-outline' }}
                </v-icon>
              </v-btn>
            </v-list-item-action>

            <ShareDialog
              :visible="openDialog"
              @input="openDialog = false"
              :item="sharedItem || {}"
              :positionX="sharedDialogPosition.positionX"
              :positionY="sharedDialogPosition.positionY"
            ></ShareDialog>
            <!-- <v-btn
              :class="['mr-2', 'mr-md-4', {
                'primary--text': $vuetify.breakpoint.mdAndUp
              }]"
              :to="link"
              :icon="$vuetify.breakpoint.smAndDown"
              :outlined="$vuetify.breakpoint.mdAndUp"
              :rounded="$vuetify.breakpoint.mdAndUp"
            >
              <v-icon>mdi-menu-left</v-icon>
              <span v-if="$vuetify.breakpoint.mdAndUp
                && ( categoryId != null || getCategory() != null )
              ">
                {{ getCategory() != null ? getCategory().name : categoryId }}
              </span>
            </v-btn>

            {{ elementData.name }}-->
          </v-card-title>

          <Form
            :id="`request-${elementIdData}`"
            :data="elementData"
            :lock="submitting"
            :key="`request-form-${elementIdData}`"
            ref="form"
            class="pa-4"
            :buttons="noData ? [] : formSubmitButtons"
            @click:submit="createTicket"
            :submitVisible="!noData"
          ></Form>
          <!--

              <v-btn
                color="primary"
                @click="createTicket"
              >{{ $t('views.form.create') }}</v-btn>
              <v-btn
                color="secondary"
                @click="createTicket($event, true)"
              >{{ $t('views.form.createAndResolve') }}</v-btn>

          -->
        </template>
      </v-card>
    </div>
  </template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Form, ShareDialog } from '@/components';
import { NAMED_ROLES } from '@/store/modules/session';
import { STATUS } from '@/store/modules/catalog';
import { STATUS as BOOKMARKS_STATUS, BOOKMARK_TYPES } from '@/store/modules/bookmarks';

const PATH_LOGIN = '/login';
const PATH_HOME = '/';

const ticketTypeToBookmarkType = (type) => {
  switch (type) {
  default:
  case 'R': return BOOKMARK_TYPES.REQUESTS;
  case 'I': return BOOKMARK_TYPES.INCIDENTS;
  }
};

export default {
  props: {
    ticketType: String,
    categoryId: String,
    categoryParent: String,
    elementId: String,
    queryParams: {
      type: Object,
      default: () => ({}),
    },
    idTicket: Number,
    method: String,
    hideViewTitle: {
      type: Boolean,
      default: () => false,
    },
    internalAccess: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
    },
  },
  components: { Form, ShareDialog },
  data() {
    return {
      loading: false,
      submitting: false,
      error: null,
      elementCopy: null,
      prevRoute: null,
      sharedItem: null,
      sharedDialogPosition: {},
      openDialog: false,
      isApproverZero: false,
      approverZeroName: '',
      prevFullRoute: null,
      elementData: null,
      ticketTypeData: null,
      elementIdData: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { path, fullPath } = from;
      let prevRoute = path.substr(1); // removes first slash
      const nextSlashIndex = prevRoute.indexOf('/');
      if (nextSlashIndex !== -1) {
        prevRoute = prevRoute.substr(0, nextSlashIndex);
      }
      // eslint-disable-next-line no-param-reassign
      vm.prevRoute = {
        path: `/${prevRoute}`,
        prevFullPath: fullPath,
      };
    });
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchForm',
    element: async function initializeElementProperties(el) {
      const idform = el.id;
      const { id: idElement, location: { id: idWorkplace } } = el;
      this.elementId = idElement;
      this.elementIdData = this.elementId;
      this.workplaceId = idWorkplace;
      localStorage.setItem('elementId', idElement);
      localStorage.setItem('workplaceId', idWorkplace);

      if (this.hasGroupTIC()) {
        try {
          this.isWorkFlow = await this.searchWorkFlow(idElement, idWorkplace);
        } catch (err) {
          this.isWorkFlow = false;
          console.log(err);
        }
      }

      if (this.queryParams != null) {
        Object.keys(this.queryParams)
          .forEach((key) => {
            const property = el.properties.find(
              (prop) => prop.alias === key,
            );
            if (property) {
              property.config = {
                initialvalue: `"${this.queryParams[key]}"`,
              };
            }
          });
      }
      if (el) {
        const { properties } = el;

        // elementForInsert
        const elementForInsert = properties
          .filter((elementData) => elementData?.special_values?.workflowInsert) || [];
        const dataForInsert = {
          id: idform,
          props: elementForInsert,
        };
        localStorage.setItem('elementForInsert', JSON.stringify(dataForInsert));

        // elementForUpdate
        const elementForUpdate = properties
          .filter((elementData) => elementData?.special_values?.workflowUpdate) || [];
        const dataForUpdate = {
          id: idform,
          props: elementForUpdate,
        };
        localStorage.setItem('elementForUpdate', JSON.stringify(dataForUpdate));
      }
      return el;
    },
    internalAccess: {
        handler: function (newVal) { // eslint-disable-line
        if (newVal) {
          const [ticketType, elementId] = this.id.split('/');
          this.ticketTypeData = ticketType;
          this.elementIdData = elementId;
          this.fetchForm();
        }
      },
    },
  },
  async created() {
    if (this.internalAccess) {
      const [ticketType, elementId] = this.id.split('/');
      this.ticketType = ticketType.toUpperCase();
      this.elementId = elementId;
      this.ticketTypeData = this.ticketType;
      this.elementIdData = this.elementId;
      this.fetchForm();
    } else {
      this.ticketTypeData = this.ticketType;
      this.elementIdData = this.elementId;
      if (!this.$store.getters['catalog/loaded'](this.ticketTypeData, this.categoryId)) {
        this.$store.dispatch('catalog/loadCatalogCategories', {
          userId: this.user.id,
          locationId: this.user.location.id,
          type: this.ticketTypeData,
        });
      }
      if (this.categoryId != null && !this.$store.getters['catalog/storedElements'](this.ticketTypeData, this.categoryId)) {
        this.$store.dispatch('catalog/loadCategoryElements', {
          categoryId: this.categoryId,
          type: this.ticketTypeData,
        });
      }
      const bookmarkType = ticketTypeToBookmarkType(this.ticketTypeData);
      const bookmarkTypeStatus = this.$store.getters['bookmarks/status'](bookmarkType);
      // if bookmarks[type] are not loaded yet we will request them
      if (![BOOKMARKS_STATUS.SUCCESS, BOOKMARKS_STATUS.LOADING].includes(bookmarkTypeStatus)) {
        this.$store.dispatch('bookmarks/get', { type: bookmarkType });
      }
      if (this.method === 'clone') {
        this.fetchCloneForm();
      } else {
        this.fetchForm();
      }
      this.$root.$on('Updatesearch', async (workplace) => {
        if (this.hasGroupTIC() && workplace) {
          const { value: workplaceId } = workplace;
          try {
            this.isWorkFlow = await this.searchWorkFlow(this.elementIdData, workplaceId);
          } catch (err) {
            this.isWorkFlow = false;
            console.log(err);
          }
        } else {
          this.isWorkFlow = false;
        }
      });
    }
  },
  methods: {
    async fetchForm() {
      this.error = null;
      this.form = null;

      this.loading = true;

      try {
        if (this.elementData == null && this.elementIdData != null) {
          await this.$store.dispatch('catalog/loadElement', {
            elementId: this.elementIdData,
            type: this.ticketTypeData,
          });
        }
      } catch (ex) {
        this.error = ex;
      }
      this.loading = false;
    },

    async fetchCloneForm() {
      this.error = null;
      this.form = null;

      this.loading = true;
      try {
        const response = await this.$api.getClient('catalog').getElementClone(
          this.idTicket,
          this.elementIdData,
        );
        if (response) {
          const dataForm = response.list[0].properties;
          const ASIG_INITIAL = 'Asignación inicial';
          for (let x = 0; x < dataForm.length; x += 1) {
            if (dataForm[x].name === ASIG_INITIAL) {
              dataForm[x].config.initialvalue = '';
            }
          }
        }
        this.elementCopy = response.unique();
      } catch (ex) {
        this.error = ex;
      }
      this.loading = false;
    },

    async createTicket($evt) {
      const { action, data, attachments } = $evt;
      const resolve = action === this.$t('views.form.createAndResolve');

      try {
        this.submitting = true;

        const notificationMessageId = await this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.form.messages.creating'),
          icon: 'progress-circular',
        });

        try {
          const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
          if (isMobile === true) {
            this.queryParams.isMobile = true;
          }
          const response = await this.$api.getClient('ticket').create(this.elementIdData, this.ticketTypeData, data, resolve, this.queryParams);

          if (!response.total) {
            throw new Error('there was an unexpected error in ticket creation: got empty response (total = 0)');
          }
          const ticket = response.unique();
          this.updateUserLocationIfNeeded(data.workplace);

          const url = resolve ? `/requests/registered/${(ticket.type.relAttr).toLowerCase()}/${ticket.id}/${ticket.name}?action=resolve`
            : `/requests/registered/${(ticket.type.relAttr).toLowerCase()}/${ticket.id}/${ticket.name}`;

          this.$router.push(url);

          const totalAttachments = attachments.concat(
            ticket.$attachments.map((attmnt) => {
              const buffer = Buffer.from(attmnt.fichero);
              if (attmnt.name) {
                buffer.name = attmnt.name;
              }
              return buffer;
            }),
          );

          if (totalAttachments.length) {
            const attachmentsClient = this.$api.getClient('attachment');
            const updateMessageStatus = (currentUpload) => {
              this.$store.dispatch('messages/updateMessage', {
                id: notificationMessageId,
                title: this.$t('views.form.messages.uploadingAttachments', [currentUpload, totalAttachments.length]),
              });
            };

            await totalAttachments.reduce((p, attmnt, idx) => p.then(async () => {
              updateMessageStatus(idx + 1);

              await attachmentsClient.upload(attmnt,
                ticket.id, this.user.userid, ticket.referenceNumber,
                this.$getConst('upload.server'), this.$getConst('upload.rep'),
                ticket.getPortafirmasRequestId());
            }), Promise.resolve());
          }

          if (ticket.hasPortafirmasRequest()) {
            await this.$api.getClient('ticket').sendPfirmas(ticket.id);
            console.log('pfirmas request sent');
          }

          this.$store.dispatch('messages/updateMessage', {
            id: notificationMessageId,
            title: this.$t(`views.form.messages.created.${this.ticketTypeData}`),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeout'),
          });
        } catch (ex) {
          console.error('error creating ticket', ex, this.elementIdData, data, this);
          const errEX = ex;
          let errorCgesCode = '';
          if (errEX && errEX.data && errEX.data.errorCgesCode) {
            errorCgesCode = errEX.data.errorCgesCode;
          }
          this.$store.dispatch('messages/updateMessage', {
            id: notificationMessageId,
            title: this.$t('views.form.messages.error', [errorCgesCode]),
            icon: 'mdi-times',
            type: 'error',
            timeout: this.$getConst('notifications.timeout'),
          });
        }

        this.submitting = false;
        return true;
      } catch (ex) {
        console.log('reject resolve message dialog:', ex.message);
        return false;
      }
    },
    updateUserLocationIfNeeded(newWorkplace) {
      const formRef = this.$refs.form;
      if (formRef != null
          && formRef.shouldUpdateUserLocation()
          && newWorkplace != null) {
        const userData = {
          location: newWorkplace,
        };
        this.$api.getClient('user').update(userData).then(() => {
          this.$store.dispatch('session/updateLocation', newWorkplace);
        });
      }
    },
    getCategory() {
      if (this.ticketTypeData == null || this.categoryId == null) {
        return null;
      }
      const typedCategories = this.$store.state.catalog.categories[this.ticketTypeData];
      return typedCategories[this.categoryId] != null
        ? typedCategories[this.categoryId].model
        : null;
    },
    isElementInBookmark() {
      const type = ticketTypeToBookmarkType(this.ticketTypeData);
      return this.$store.getters['bookmarks/isInBookmark'](type, this.elementIdData);
    },
    async toggleFav(evt) {
      evt.preventDefault();

      const action = this.isElementInBookmark(this.elementIdData) ? 'bookmarks/remove' : 'bookmarks/add';
      try {
        await this.$store.dispatch(action, {
          type: ticketTypeToBookmarkType(this.ticketTypeData),
          element: {
            id: this.elementIdData,
            name: this.elementData.name,
          },
        });
      } catch (ex) {
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('ticketActions.messages.error'),
          icon: 'mdi-times',
          type: 'error',
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    share(evt) {
      console.log('evt', evt);
      evt.preventDefault();
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          name: `${this.$t(`components.share.subjectBody.${this.ticketTypeData}`)} ${this.elementData.name}`,
          url: `${window.location.origin}${this.$router.options.base}element/${this.ticketTypeData.toLowerCase()}/${this.elementIdData}`,
          formName: this.elementData.name,
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}element/${this.ticketTypeData.toLowerCase()}/${this.elementIdData}`;
        this.openDialog = true;
        this.sharedItem = {
          text: `${this.$t(`components.share.subjectBody.${this.ticketTypeData}`)} ${this.elementData.name}`,
          url: fullShareUrl,
          formName: this.elementData.name,
        };

        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
    hasGroupTIC() {
      return this.user.ticGroupMember;
    },
    async searchWorkFlow(elementId, idWorkplace) {
      const client = this.$api.getClient('search');
      try {
        const response = await client.search({
          target: 'namedquery',
          entity: 'ticketApprovalWorkflowTemplate',
          filters: {
            elementData: elementId,
            location: idWorkplace,
          },
        });

        return response.list.length > 0;
      } catch (err) {
        return err;
      }
    },
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
      loaded: ({ catalog: { status } }) => [STATUS.SUCCESS, STATUS.ERROR].includes(status),
      element: function mapElement({ catalog }) {
        // create a copy of the element to prevent
        // query params initialvalues caching
        const element = this.elementCopy !== null
          ? this.elementCopy : catalog.elements[this.elementIdData];

        const res = element != null ? ({
          ...element,
          properties: element.properties.map(
            (property) => ({ ...property }),
          ),
        }) : null;

        if (res != null) this.elementData = res;
        return res;
      },
    }),
    noData() {
      // verify if element properties are only of type 'description'
      // to hide submit buttons (the element will be considered as info element)
      return this.elementData != null
          && this.elementData.properties.length
          && this.elementData.properties.every((property) => property.type.name === 'description' || (property.params || {}).save === 'false');
    },
    formSubmitButtons() {
      const submitButtons = [this.$t('views.form.create')];
      if (this.hasRoles(NAMED_ROLES.VIEW_CSU) || (this.hasGroupTIC() && !this.isWorkFlow)) {
        submitButtons.push(this.$t('views.form.createAndResolve'));
      }
      return submitButtons;
    },
    link() {
      const url = {
        R: `/request/${this.categoryId ? this.categoryId : ''}`,
        I: '/incident/',
        default: '/',
      };
      return url[this.ticketTypeData] || url.default;
    },
    crumbs() {
      const routePath = this.$route.path.endsWith('/') ? this.$route.path.slice(0, -1) : this.$route.path;
      const paths = routePath.split('/');
      paths.slice(0, 1); // remove first slash
      const category = this.getCategory();
      const { element } = this;

      const prevPath = (this.prevRoute && this.prevRoute.path === PATH_LOGIN)
        ? PATH_HOME
        : (this.prevRoute || {}).path || PATH_HOME;

      const breadcrumbs = [{
        path: paths.splice(0, 1),
        text: 'mdi-keyboard-backspace',
        to: prevPath === this.$route.path ? '/home' : prevPath,
      }];

      // if category is not null we have access from catalog categories
      if (this.categoryId != null && this.ticketTypeData === 'R' && this.$vuetify.breakpoint.mdAndUp) {
        let path = '';
        if (this.categoryParent) {
          path = paths.splice(0, 4).join('/');
        } else {
          path = paths.splice(0, 2).join('/');
        }

        breadcrumbs.push({
          path,
          to: `${breadcrumbs[0].path}/${path}`,
          text: category != null ? category.name : this.categoryId,
        });
      }

      breadcrumbs.push({
        text: element != null ? element.name : this.elementIdData,
      });
      return breadcrumbs;
    },
    NAMED_ROLES: () => NAMED_ROLES,
  },
};

</script>
  <style lang="scss" scoped>
    .text-subtitle-1 {
      word-break: break-word;

      -webkit-hyphens: auto;
      -moz-hyphens: auto;
      hyphens: auto;
    }
  </style>
